import React, { FC } from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Trans } from "react-i18next";

export const Container = styled.section`
  background-color: ${({ theme }) => theme.duo.palette.white};
  border-radius: 15px;
  padding: 10px;
  margin-top: 10px;
  width: 100%;
  max-width: 350px;
  margin: 10px auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 50px minmax(80px, auto);
  row-gap: 1px;
  background-color: ${({ theme }) => theme.duo.palette.blueLighter};
`;

export const Row = styled.div`
  display: contents;
`;

export const Label = styled.div`
  padding: 0 10px;
  font-size: 14px;
  font-family: "Noto Sans", "Segoe UI", sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  color: ${({ theme }) => theme.duo.color.text};
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.duo.color.white};
`;

export const WhiteCell = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.duo.palette.white};
`;

export const Cell = styled.div<{ $isPremium?: boolean; $isFirst?: boolean; $isLast?: boolean }>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $isPremium, theme }) => ($isPremium ? theme.duo.color.lightGreen : theme.duo.palette.white)};
  border-radius: ${({ $isFirst, $isLast }) => ($isFirst ? "17px 17px 0 0" : $isLast ? "0 0 17px 17px" : "0")};
  padding: ${({ $isFirst }) => ($isFirst ? "7px 6px" : "5px")};
`;

export const Header = styled.div<{ $isPremium?: boolean }>`
  background-color: ${({ $isPremium, theme }) =>
    $isPremium ? theme.duo.palette.greenMedium : theme.duo.palette.white};
  border-radius: 100px;
  padding: 5px 10px;
  color: ${({ $isPremium, theme }) => ($isPremium ? theme.duo.color.white : theme.duo.palette.greyDark)};
  font-weight: ${({ theme }) => theme.duo.fontWeight.w700};
  font-size: 10px;
  text-align: center;
`;

export const IconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: ${({ theme }) => theme.duo.palette.white};
  background-color: transparent;
`;

export const CheckIcon = styled(FontAwesomeIcon)<{ $isPremium?: boolean }>`
  && {
    font-size: 24px;
    color: ${({ $isPremium, theme }) => ($isPremium ? theme.duo.palette.greenMedium : theme.duo.palette.greyDark)};
  }
`;

export const Dash = styled.div`
  position: relative;
  width: 10px;
  height: 1px;
  &::before {
    content: "";
    position: absolute;
    width: 10px;
    height: 1px;
    left: 0;
    top: 0;
    border-top: ${({ theme }) => `1px solid ${theme.duo.palette.greyDark}`};
  }
`;

export const PremiumValue = styled.div`
  font-weight: ${({ theme }) => theme.duo.fontWeight.w700};
  color: ${({ theme }) => theme.duo.palette.greenMedium};
  font-size: 14px;
`;

// Shared Header Row Component
export const HeaderRow: FC = () => (
  <Row>
    <Label />
    <Cell>
      <Header>
        <Trans>FREE</Trans>
      </Header>
    </Cell>
    <WhiteCell>
      <Cell $isPremium $isFirst>
        <Header $isPremium>
          <Trans>PREMIUM</Trans>
        </Header>
      </Cell>
    </WhiteCell>
  </Row>
);
